import { RxStompConfig } from '@stomp/rx-stomp';

enum ServerMessagesEndpoint {
  Topic = '/topic',
  Hub = '/hub',
  Load = '/load',
  Uli = '/uli',
  NotaFiscal = '/nota_fiscal',
}

export enum TopicsEnum {
  Hub = 'HUB',
  Load = 'LOAD',
  Uli = 'ULI',
  NotaFiscal = 'NOTA_FISCAL',
}

export const TOPICS_URLS: Record<TopicsEnum, string> = {
  [TopicsEnum.Hub]: `${ServerMessagesEndpoint.Topic}${ServerMessagesEndpoint.Hub}/:hubId`,
  [TopicsEnum.Load]: `${ServerMessagesEndpoint.Topic}${ServerMessagesEndpoint.Hub}/:hubId${ServerMessagesEndpoint.Load}/:loadNumber`,
  [TopicsEnum.Uli]: `${ServerMessagesEndpoint.Topic}${ServerMessagesEndpoint.Hub}/:hubId${ServerMessagesEndpoint.Uli}/:uliId`,
  [TopicsEnum.NotaFiscal]: `${ServerMessagesEndpoint.Topic}${ServerMessagesEndpoint.NotaFiscal}/:hubId`,
};

export const STOMP_DEFAULT_CONFIG: RxStompConfig = {
  brokerURL: '',
  connectHeaders: {},
  heartbeatIncoming: 0,
  heartbeatOutgoing: 20000,
  reconnectDelay: 5000,
};
